


















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import dayjs from "dayjs";
import { Toast } from 'vant';
import { TbGoodsSpecs } from '@/http';
import  dialogPanel  from "./dialogPanel.vue"
@Component({
    components: {
      dialogPanel
    },
})
export default class addSpecsPanel extends Vue {
    public $refs: {
    };

    @Prop({
        default:false
    })
    show:Boolean;
    @Prop({
        default:true
    })
    isAddName:Boolean;
    @Prop({
        default:null
    })
    isEdit;

    @Prop({
        type:Object,
        default:()=>{
            return {
               id:"",
               name:"",
               delSpecsItemsJson:[],
               specsItemsJson:[],
            };
        }
    })
    parentInfo:any;

    form:any={}

    @Watch('parentInfo')
    parentInfoChange(val){
        this.form = val;
    }

    name="";
    ggzid = '';
    oldggz = null;
    isLoading=false;
  

    created() {
    }
    mounted() {
    }
    init(){
        this.$nextTick(() => {
            $("#input1").focus();
        });
    }
    init1(item){
        this.name = item.name;
        this.ggzid = item.id;
        this.oldggz = item;
        console.log('this.oldggz',this.oldggz);
        this.$nextTick(() => {
            $("#input1").focus();
        });
    }
    init2(){
        this.$nextTick(() => {
            this.$refs['input11'].focus();
        });
    }
    cancelFun(){
        this.resetForm();
        this.$emit('cancelFun');
    }
    resetForm(){
        this.name = "";
    }
    async saveFun(){
        if(!this.name){
            let str = this.isAddName?'请输入规格':'请输入规格值';
            Toast(str);
            return;
        }
        if(this.isLoading)return;
        this.isLoading = true;
        if(this.isEdit){
            //编辑 1规格 2规格值
            if(this.isEdit==1){
                console.log('规格哦');
                console.log('this.form',this.form);
                let arr = this.form.specsItemsJson;
                try {
                    let res =await TbGoodsSpecs.PutTbGoodsSpecs({
                        id:this.form.id,
                        name:this.name,
                        delSpecsItemsJson:[],
                        specsItemsJson:arr
                    })
                    this.isLoading = false;
                    Toast("编辑成功");
                    this.$emit('confirmAdd');
                    this.cancelFun();
                } catch (error) {
                    this.isLoading = false;
                }
            }else{
                console.log('规格值哦');
                console.log('this.form',this.form);
                let arr = this.form.specsItemsJson;
                let editArr = this.form.specsItemsJson.map(v=>{
                    return {
                        ...v,
                        name:v.id==this.ggzid?this.name:v.name
                    }
                })
                try {
                    let res =await TbGoodsSpecs.PutTbGoodsSpecs({
                        id:this.form.id,
                        name:this.form.name,
                        delSpecsItemsJson:[this.oldggz],
                        specsItemsJson:editArr
                    })
                    this.isLoading = false;
                    Toast("编辑成功");
                    this.$emit('confirmAdd');
                    this.cancelFun();
                } catch (error) {
                    this.isLoading = false;
                }
            }
        }else {
            //新增
            if(this.isAddName){
                try {
                    let res =await TbGoodsSpecs.PostTbGoodsSpecs({
                        name:this.name
                    })
                    this.isLoading = false;
                    Toast("新增成功");
                    this.$emit('confirmAdd')
                    this.cancelFun();
                } catch (error) {
                    this.isLoading = false;
                }            
            }else{
                let arr = this.form.specsItemsJson;
                // console.log('arr',arr);
                
                arr.push({
                    id: this.form.specsItemsJson.length>0?this.getCurMax(this.form.specsItemsJson):1,
                    name:this.name
                })
                let addItem={
                    id:this.form.id,
                    name:this.form.name,
                    childList:[
                        {
                            id:this.form.specsItemsJson.length>0?this.getCurMax2(this.form.specsItemsJson):1,
                            name:this.name
                        }
                    ]
                }
                try {
                    let res =await TbGoodsSpecs.PutTbGoodsSpecs({
                        id:this.form.id,
                        name:this.form.name,
                        delSpecsItemsJson:[],
                        specsItemsJson:arr
                    })
                    this.isLoading = false;
                    Toast("新增成功");
                    this.$emit('confirmAdd',addItem)
                    this.cancelFun();
                } catch (error) {
                    this.isLoading = false;
                    this.cancelFun();
                    this.$emit('confirmAdd')
                }
            }
        }
    }
    delItem(){
        this.$emit('delItem')
        this.cancelFun();

    }
    getCurMax(list){
      let arr =list.map(v=>v.id)
      return (Math.max(...arr)+1);
    }
    getCurMax2(list){
      let arr =list.map(v=>v.id)
      return (Math.max(...arr));
    }

    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/addSpecsPanel.vue